__webpack_require__.p = "https://happy-pond-08c82e503.2.azurestaticapps.net/";